import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

// This component restores scroll position on back/forward, scrolls to top on new navigation
const ScrollRestoration = () => {
  const location = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    const key = location.key || location.pathname;
    if (navigationType === 'POP') {
      // Restore scroll position
      const y = sessionStorage.getItem('scroll-' + key);
      if (y) {
        window.scrollTo(0, parseInt(y, 10));
      }
    } else {
      // New navigation: scroll to top
      window.scrollTo(0, 0);
    }
  }, [location, navigationType]);

  useEffect(() => {
    const key = location.key || location.pathname;
    const saveScroll = () => {
      sessionStorage.setItem('scroll-' + key, window.scrollY);
    };
    window.addEventListener('scroll', saveScroll);
    return () => window.removeEventListener('scroll', saveScroll);
  }, [location]);

  return null;
};

export default ScrollRestoration; 